import React from 'react'

import styled from 'styled-components'

interface ItemsViewToolbarProps {
  children: React.ReactNode
  className?: string
}

export const ItemsViewToolbar: React.FC<ItemsViewToolbarProps> = ({
  children,
  className
}) => {
  return (
    <SContainer className={className}>
      {children}
    </SContainer>
  )
}

const SContainer = styled.div`
  width: 100%;
  border-bottom: 1px solid var(--border-color-secondary);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 11px 0 11px 20px;
  background: #ffffff;
  margin-bottom: 24px;
  box-sizing: border-box;
`
